// extracted by mini-css-extract-plugin
export var card = "Banner-module--card--T1AK3";
export var careers = "Banner-module--careers--TeZ1A";
export var illustration = "Banner-module--illustration--wHK0B";